import React, { useEffect, useState } from 'react';
import { Trophy, Fingerprint, HandHeart, Sparkles, Loader2 } from 'lucide-react';
import { api } from '../context/AuthContext';

const RANK_COLORS = ['#f59e0b', '#94a3b8', '#b45309'];

export const SecurityLeaderboard = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/security/leaderboard').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <section className="py-16 sm:py-20" data-testid="security-leaderboard-section">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-[11px] tracking-[0.18em] uppercase font-semibold text-[#d97757]">Leaderboard</div>
        <h2 className="mt-2 text-[clamp(1.4rem,2.5vw,1.9rem)] font-semibold tracking-tight text-[#1a1d1a]">Classement Sécurité</h2>
        <p className="mt-2 text-[14px] text-neutral-600 max-w-[560px]">
          Les membres les plus engagés dans la sécurité de la communauté : passkey biométrique activée, profil complété, cagnottes créées et dons effectués.
        </p>

        <div className="mt-6 rounded-3xl bg-white border border-black/5 overflow-hidden">
          {items === null ? (
            <div className="py-12 text-center"><Loader2 className="w-5 h-5 animate-spin inline-block text-neutral-400" /></div>
          ) : items.length === 0 ? (
            <div className="py-12 text-center text-[13.5px] text-neutral-500 px-6">
              Le classement est vide pour l'instant. Activez votre passkey biométrique depuis votre tableau de bord pour prendre la tête !
            </div>
          ) : (
            items.map((u, i) => (
              <div key={`${u.name}-${i}`} className="flex items-center gap-4 px-5 py-4 border-b border-black/5 last:border-0" data-testid={`leaderboard-row-${i + 1}`}>
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center font-bold text-[14px] shrink-0"
                  style={i < 3 ? { background: `${RANK_COLORS[i]}1f`, color: RANK_COLORS[i] } : { background: '#f5f4ef', color: '#6b7280' }}
                >
                  {i < 3 ? <Trophy className="w-4 h-4" /> : i + 1}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-[14px] text-neutral-900 truncate">{u.name}</div>
                  <div className="text-[11.5px] text-neutral-500">{u.phoneMasked}</div>
                </div>
                <div className="hidden sm:flex items-center gap-3 text-[11.5px] text-neutral-500">
                  {u.passkeys > 0 && <span className="flex items-center gap-1" title="Passkeys"><Fingerprint className="w-3.5 h-3.5 text-[#5a8268]" /> {u.passkeys}</span>}
                  {u.donations > 0 && <span className="flex items-center gap-1" title="Dons"><HandHeart className="w-3.5 h-3.5 text-[#d97757]" /> {u.donations}</span>}
                  {u.cagnottes > 0 && <span className="flex items-center gap-1" title="Cagnottes"><Sparkles className="w-3.5 h-3.5 text-[#0e3a3a]" /> {u.cagnottes}</span>}
                </div>
                <div className="text-[15px] font-semibold text-[#1a1d1a] shrink-0">{u.score} <span className="text-[11px] font-medium text-neutral-500">pts</span></div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};
